import { type ReactNode } from 'react';
import { useMe } from '@/hooks/useMe';
import { isStandalone } from '@/lib/tg';
import LoginScreen from '@/routes/auth/LoginScreen';
import RegisterName from '@/components/RegisterName';
import SuspendedScreen from '@/components/SuspendedScreen';

/**
 * Гейт: авто-приостановленный стажёр → экран восстановления (и в Telegram, и в вебе).
 * Дальше standalone-веб: нет сессии → логин; нет ФИО → ввод имени. В Telegram прозрачен.
 */
export function AuthGate({ children }: { children: ReactNode }) {
  // useMe вызывается безусловно (hook-safe).
  const { data: me, isLoading, error } = useMe();
  // Ждём /api/me и в Telegram тоже — иначе приостановленный мелькнул бы приложением.
  if (isLoading) return <div className="p-6 text-tg-hint">Загрузка…</div>;
  if (me?.suspended) return <SuspendedScreen />;
  if (!isStandalone()) return <>{children}</>;
  if (error || !me) return <LoginScreen />;
  if (!me.fullName) return <RegisterName />;
  return <>{children}</>;
}
